import { cleanUserDataForApi, formatBirthDateForApi } from '../../../helpers';
import { getFormattedAddress } from '../../../utils/utils';
import { getLocationProp } from '../../partials/LocationInput/utils';

export function parseAddressForApi(formValues) {
  const { address, city, postalCode, country } = formValues;
  const streetName = getLocationProp(address, 'streetName');
  const countryISO = getLocationProp(country, 'countryISO');

  return {
    city,
    country: countryISO,
    formattedAddress: getFormattedAddress({
      streetName,
      city,
      postalCode,
      countryIso: countryISO
    }),
    postalCode,
    streetName
  };
}

export function formatPersonalDetailsForApiCall(userData = {}, formValues = {}) {
  const { phoneNumber, civility, birthDate, firstName, lastName } = formValues;
  const { phonePrefix, phoneSuffix } = phoneNumber || {};

  const requiredData = {
    ...userData,
    firstName,
    lastName,
    civility,
    birthDate: formatBirthDateForApi(birthDate),
    address: parseAddressForApi(formValues),
    phoneNumber: {
      countryCode: phonePrefix,
      nationalNumber: phoneSuffix
    }
  };

  return cleanUserDataForApi(requiredData);
}



/** WEBPACK FOOTER **
 ** ./src/components/account/PersonalDetails/helpers.js
 **/